import { useState, useEffect } from 'react';
import { gamingProducts as mockGaming, officeProducts as mockOffice } from '../data/mock';

const API_URL = process.env.REACT_APP_BACKEND_URL;

export function useProducts(type) {
  const [products, setProducts] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    let cancelled = false;
    const fetchProducts = async () => {
      try {
        const url = type
          ? `${API_URL}/api/public/products?type=${type}`
          : `${API_URL}/api/public/products`;
        const res = await fetch(url);
        if (!res.ok) throw new Error('API error');
        const data = await res.json();
        if (!cancelled) {
          setProducts(data);
          setLoading(false);
        }
      } catch {
        // Fallback to mock data
        if (!cancelled) {
          if (type === 'gaming') setProducts(mockGaming);
          else if (type === 'office') setProducts(mockOffice);
          else setProducts([...mockGaming, ...mockOffice]);
          setLoading(false);
        }
      }
    };
    fetchProducts();
    return () => { cancelled = true; };
  }, [type]);

  return { products, loading };
}

export function useProduct(id) {
  const [product, setProduct] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    let cancelled = false;
    const fetchProduct = async () => {
      try {
        const res = await fetch(`${API_URL}/api/public/products/${id}`);
        if (!res.ok) throw new Error('API error');
        const data = await res.json();
        if (!cancelled) {
          setProduct(data);
          setLoading(false);
        }
      } catch {
        // Fallback to mock
        const all = [...mockGaming, ...mockOffice];
        if (!cancelled) {
          setProduct(all.find(p => p.id === id) || null);
          setLoading(false);
        }
      }
    };
    fetchProduct();
    return () => { cancelled = true; };
  }, [id]);

  return { product, loading };
}
